/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SignUpWithOIDCContainer_auth = {
    readonly integrations: {
        readonly oidc: {
            readonly name: string | null;
            readonly redirectURL: string | null;
        };
    };
    readonly " $refType": "SignUpWithOIDCContainer_auth";
};
export type SignUpWithOIDCContainer_auth$data = SignUpWithOIDCContainer_auth;
export type SignUpWithOIDCContainer_auth$key = {
    readonly " $data"?: SignUpWithOIDCContainer_auth$data;
    readonly " $fragmentRefs": FragmentRefs<"SignUpWithOIDCContainer_auth">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SignUpWithOIDCContainer_auth",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "AuthIntegrations",
            "kind": "LinkedField",
            "name": "integrations",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "OIDCAuthIntegration",
                    "kind": "LinkedField",
                    "name": "oidc",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "redirectURL",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Auth",
    "abstractKey": null
} as any);
(node as any).hash = 'f694dd58c142a0f79a00a9c562d54735';
export default node;
